/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMapPin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M12 1.75A8.25 8.25 0 003.75 10c0 3.198 2.074 6.266 4.294 8.61A29.677 29.677 0 0012 22.082a29.672 29.672 0 003.956-3.473c2.22-2.344 4.294-5.412 4.294-8.61A8.25 8.25 0 0012 1.75zM12 23l-.416.624-.003-.002-.006-.004-.022-.015a11.758 11.758 0 01-.379-.267 31.168 31.168 0 01-4.219-3.696C4.676 17.235 2.25 13.803 2.25 10a9.75 9.75 0 0119.5 0c0 3.802-2.426 7.234-4.706 9.64a31.173 31.173 0 01-4.218 3.697 18.242 18.242 0 01-.379.266l-.022.015-.006.004-.002.001s-.001.001-.417-.623zm0 0l.416.624a.75.75 0 01-.832 0L12 23zm0-15.25a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM8.25 10a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0z'
      />
    </svg>
  );
}

export default SvgMapPin;
